/**
 * @generated SignedSource<<1aaaa662577646c394f38d850e964e61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventsDashboardBlockCardViewQuery$variables = {
  first?: number | null;
  organizationId: string;
  productId: string;
};
export type EventsDashboardBlockCardViewQuery$data = {
  readonly organization: {
    readonly " $fragmentSpreads": FragmentRefs<"EventsDashboardBlockCardView_OrganizationPaginationFragment" | "usePermissionsFragment">;
  } | null;
  readonly product: {
    readonly slug?: string;
    readonly " $fragmentSpreads": FragmentRefs<"EventsDashboardBlockCardView_ProductPaginationFragment" | "usePermissionsFragment">;
  } | null;
};
export type EventsDashboardBlockCardViewQuery = {
  response: EventsDashboardBlockCardViewQuery$data;
  variables: EventsDashboardBlockCardViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "organizationId"
  }
],
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "usePermissionsFragment"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "datetimeFilter",
    "value": "upcoming"
  },
  (v4/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = [
  (v12/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Organization",
  "abstractKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "nonNullProductId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v18/*: any*/),
    (v21/*: any*/)
  ],
  "type": "Product",
  "abstractKey": null
},
v23 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v18/*: any*/),
  (v21/*: any*/)
],
v24 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "Event",
  "abstractKey": null
},
v25 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v18/*: any*/),
  (v21/*: any*/)
],
v26 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "Comment",
  "abstractKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "Feed",
  "abstractKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "Post",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "nullableProductIdString",
      "args": null,
      "kind": "ScalarField",
      "name": "productId",
      "storageKey": null
    },
    (v18/*: any*/),
    (v21/*: any*/)
  ],
  "type": "ContentUsage",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "ChatChannel",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "Dashboard",
  "abstractKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "AssignmentSubmission",
  "abstractKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "PathwayGroup",
  "abstractKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "BrainSearch",
  "abstractKey": null
},
v35 = [
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "OccurrenceNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Occurrence",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "datetimeRange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "coverPhoto",
            "storageKey": null
          },
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isComplete",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visibility",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OccurrenceHostNodeConnection",
            "kind": "LinkedField",
            "name": "hosts",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "product",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cover",
                "storageKey": null
              },
              (v16/*: any*/),
              (v13/*: any*/),
              (v8/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductMembership",
                "kind": "LinkedField",
                "name": "viewerMembership",
                "plural": false,
                "selections": [
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "memberGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentMemberGroupId",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSystem",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRecurring",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasViewerBookmarked",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasViewerRSVPd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "atCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timezone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "OccurrenceMediaNodeConnection",
            "kind": "LinkedField",
            "name": "media",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OccurrenceMediaNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceMedia",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "media(first:1)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserMembershipNodeConnection",
            "kind": "LinkedField",
            "name": "guestReport",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              }
            ],
            "concreteType": "OccurrenceRSVPNodeConnection",
            "kind": "LinkedField",
            "name": "rsvps",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OccurrenceRSVPNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceRSVP",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "rsvps(first:3)"
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfoObjectType",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }
],
v36 = {
  "kind": "InlineFragment",
  "selections": [
    (v20/*: any*/),
    (v22/*: any*/),
    (v24/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v37 = [
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "isUpcoming",
    "value": true
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventsDashboardBlockCardViewQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v5/*: any*/),
                "kind": "FragmentSpread",
                "name": "EventsDashboardBlockCardView_OrganizationPaginationFragment"
              },
              (v6/*: any*/)
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "product",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              {
                "args": (v5/*: any*/),
                "kind": "FragmentSpread",
                "name": "EventsDashboardBlockCardView_ProductPaginationFragment"
              },
              (v6/*: any*/)
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "EventsDashboardBlockCardViewQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "OccurrenceNodeConnection",
                "kind": "LinkedField",
                "name": "occurrences",
                "plural": false,
                "selections": (v35/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "filters": [
                  "datetimeFilter"
                ],
                "handle": "connection",
                "key": "EventsDashboardBlockCardView__occurrences",
                "kind": "LinkedHandle",
                "name": "occurrences"
              },
              (v36/*: any*/)
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "product",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": (v37/*: any*/),
                "concreteType": "OccurrenceNodeConnection",
                "kind": "LinkedField",
                "name": "eventOccurrences",
                "plural": false,
                "selections": (v35/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v37/*: any*/),
                "filters": [
                  "isUpcoming"
                ],
                "handle": "connection",
                "key": "EventsDashboardBlockCardView__eventOccurrences",
                "kind": "LinkedHandle",
                "name": "eventOccurrences"
              },
              (v36/*: any*/)
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61f892c813b3fd0bb7635f413178a894",
    "id": null,
    "metadata": {},
    "name": "EventsDashboardBlockCardViewQuery",
    "operationKind": "query",
    "text": "query EventsDashboardBlockCardViewQuery(\n  $organizationId: ID!\n  $first: Int\n  $productId: ID!\n) {\n  organization: node(id: $organizationId) {\n    __typename\n    ... on Organization {\n      ...EventsDashboardBlockCardView_OrganizationPaginationFragment_3ASum4\n      ...usePermissionsFragment\n    }\n    id\n  }\n  product: node(id: $productId) {\n    __typename\n    ... on Product {\n      slug\n      ...EventsDashboardBlockCardView_ProductPaginationFragment_3ASum4\n      ...usePermissionsFragment\n    }\n    id\n  }\n}\n\nfragment BookmarkButtonContentFragment on Content {\n  id\n  hasViewerBookmarked\n}\n\nfragment DeleteOccurrenceButtonFragment on Occurrence {\n  id\n}\n\nfragment EventsDashboardBlockCardView_OrganizationPaginationFragment_3ASum4 on Organization {\n  occurrences(first: $first, datetimeFilter: upcoming) {\n    totalCount\n    edges {\n      node {\n        id\n        ...OccurrenceListItemFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment EventsDashboardBlockCardView_ProductPaginationFragment_3ASum4 on Product {\n  eventOccurrences(first: $first, isUpcoming: true) {\n    totalCount\n    edges {\n      node {\n        id\n        ...OccurrenceListItemFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment MemberGroupEventTagListFragment on Event {\n  id\n  product {\n    type\n    id\n  }\n  memberGroups {\n    edges {\n      node {\n        id\n        kind\n        parentMemberGroupId\n        name\n        product {\n          name\n          id\n        }\n        ...MemberGroupTagFragment\n      }\n    }\n  }\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment OccurrenceAttendingButtonFragment on Occurrence {\n  id\n  product {\n    id\n    slug\n    type\n  }\n}\n\nfragment OccurrenceListItemFragment on Occurrence {\n  id\n  name\n  datetimeRange\n  coverPhoto\n  status\n  isComplete\n  visibility\n  appId\n  hosts {\n    totalCount\n  }\n  product {\n    id\n    cover\n    type\n    name\n    slug\n    status\n  }\n  event {\n    id\n    ...MemberGroupEventTagListFragment\n    ...usePermissionsFragment\n    memberGroups {\n      totalCount\n    }\n  }\n  content {\n    id\n    hasViewerBookmarked\n    ...BookmarkButtonContentFragment\n  }\n  ...OccurrenceNameAndTimeFragment\n  ...OccurrenceRSVPAttendanceStatusFragment\n  ...OccurrenceStatusChipFragment\n  ...OccurrenceWatchVideoButtonFragment\n  ...DeleteOccurrenceButtonFragment\n  guestReport {\n    totalCount\n  }\n  rsvps(first: 3) {\n    totalCount\n    edges {\n      node {\n        id\n        user {\n          fullName\n          id\n        }\n      }\n    }\n  }\n  media(first: 1) {\n    edges {\n      node {\n        id\n        url\n        kind\n      }\n    }\n  }\n}\n\nfragment OccurrenceNameAndTimeFragment on Occurrence {\n  id\n  name\n  datetimeRange\n  event {\n    isRecurring\n    id\n  }\n}\n\nfragment OccurrenceRSVPAttendanceStatusFragment on Occurrence {\n  id\n  product {\n    id\n    slug\n    type\n  }\n  ...RSVPToEventButtonFragment\n  ...occurrenceUtils_useOccurrenceStatusFragment\n  ...OccurrenceRegisterAndRSVPButtonFragment\n  ...OccurrenceAttendingButtonFragment\n}\n\nfragment OccurrenceRegisterAndRSVPButtonFragment on Occurrence {\n  id\n  product {\n    id\n    slug\n    type\n  }\n}\n\nfragment OccurrenceStatusChipFragment on Occurrence {\n  id\n  datetimeRange\n  ...occurrenceUtils_useOccurrenceStatusFragment\n}\n\nfragment OccurrenceWatchVideoButtonFragment on Occurrence {\n  id\n  ...occurrenceUtils_useOccurrenceStatusFragment\n}\n\nfragment RSVPToEventButtonFragment on Occurrence {\n  id\n  status\n  hasViewerRSVPd\n  capacity\n  atCapacity\n  event {\n    id\n    isRecurring\n  }\n}\n\nfragment occurrenceUtils_useOccurrenceStatusFragment on Occurrence {\n  id\n  datetimeRange\n  hasViewerRSVPd\n  timezone\n  product {\n    viewerMembership {\n      id\n    }\n    id\n  }\n  media(first: 1) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  event {\n    ...usePermissionsFragment\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "c159ce5ea7a8d5048075a654c6c06522";

export default node;
